import { controls,grouped } from "../controls";
const account_gold_details = {
label: "Account Gold Details",
pageLabel: "Account Gold Details",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Gold Ornament Type Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "gold_ornament_type_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Valuator Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "valuator_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Quantity"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "quantity",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Descn"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "descn",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "filter", label: "Gross Weight"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "gross_weight",maxlength:15}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Net Weight"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "net_weight",maxlength:15}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Gold Rate"}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "gold_rate",maxlength:11}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "filter", label: "Returned On",target: "returned_on"}),
...controls.magicDate({ tab: "filter", name: "returned_on", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Receipt Number"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "receipt_number",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Gold Ornament Type",star:false}),
...controls.oc({ tab: "general", c: "GoldOrnamentType", placeHolder: "Gold Ornament Type Code", name: "gold_ornament_type_code", isRequired:false,fastpath:"gold_ornament_types"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "gold_ornament_type_display"}),
...controls.displayText({ tab: "general", label: "Valuator",star:false}),
...controls.oc({ tab: "general", c: "Valuator", placeHolder: "Valuator Code", name: "valuator_code", isRequired:false,fastpath:"valuators"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "valuator_display"}),
...controls.displayText({ tab: "general", label: "Quantity",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "quantity",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Descn",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "descn",isRequired:false,width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Gross Weight"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "gross_weight",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Net Weight"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "net_weight",maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Gold Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "gold_rate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Returned On",target: "returned_on",star:false}),
...controls.magicDate({ tab: "general", name: "returned_on", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Receipt Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "receipt_number",isRequired:false,maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Account Gold Details",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Gold Ornament Type Id",accessor: "gold_ornament_type_id",},
{Header: "Valuator Id",accessor: "valuator_id",},
{Header: "Quantity",accessor: "quantity",},
{Header: "Descn",accessor: "descn",},
{Header: "Gross Weight",accessor: "gross_weight",},
{Header: "Net Weight",accessor: "net_weight",},
{Header: "Gold Rate",accessor: "gold_rate",},
{Header: "Returned On",accessor: "returned_on",type:'date'},
{Header: "Receipt Number",accessor: "receipt_number",},
]}};
export default account_gold_details;